import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, Transition as _Transition } from "vue"

const _hoisted_1 = {
  class: "d-flex justify-center",
  style: {"width":"100%"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!

  return (_openBlock(), _createBlock(_Transition, { name: "slide-fade" }, {
    default: _withCtx(() => [
      (_ctx.currentMessage)
        ? (_openBlock(), _createBlock(_component_v_snackbar, {
            key: 'message-component-' + _ctx.MessagesStore.messageCount,
            value: true,
            bottom: "",
            timeout: _ctx.currentMessage.timeout || 5000,
            color: _ctx.color,
            onInput: _ctx.MessagesStore.popMessage,
            onClick: _ctx.handleSnackbarClicked
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_1, [
                _createElementVNode("span", null, [
                  _createElementVNode("span", {
                    class: _normalizeClass(["subtitle-1", _ctx.textColor])
                  }, _toDisplayString(_ctx.currentMessage.text), 3),
                  (_ctx.currentMessage.href)
                    ? (_openBlock(), _createBlock(_component_v_btn, {
                        key: 0,
                        class: "ml-3 text-none",
                        variant: "outlined",
                        color: _ctx.buttonColor
                      }, {
                        default: _withCtx(() => [
                          (_ctx.currentMessage.hrefText)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode(_toDisplayString(_ctx.currentMessage.hrefText), 1)
                              ], 64))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createTextVNode(_toDisplayString(_ctx.currentMessage.href), 1)
                              ], 64))
                        ]),
                        _: 1
                      }, 8, ["color"]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _: 1
          }, 8, ["timeout", "color", "onInput", "onClick"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}